// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"349":"email-editor","552":"chartjs"}[chunkId] || chunkId) + "-" + {"14":"1bcd5b6c44c488eafabb","349":"9e586400475d7484681f","492":"39b68342e99bd0d34f48","552":"158ffb564be39ad3f1bd","818":"6f8de814a248b0210ad6"}[chunkId] + ".chunk.js";
};